import Sticky from "react-stickynode"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import dynamic from "next/dynamic"
import MetaData from "@/common/components/MetaData"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))

import { DarkBGWrapper, LayoutWrapper } from "@/common/components/LayoutStyle"
import ProductCTA from "@/common/components/ProductCTA"
import { ProductBanner } from "@/common/components/ProductBanner"
import { ProductCategories, ProductNames } from "@/common/data/Products"
import Footer from "@/containers/common/FooterNew"
import ProductCardList from "@/common/components/ProductCard/ProductCardList"

const AllProductsPage = () => {
  const { t } = useTranslation(["allProducts"])

  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/products"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/products"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/products"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/products"
          }
        ]}
      />

      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <DarkBGWrapper></DarkBGWrapper>
      <LayoutWrapper>
        <ProductBanner
          bannerType={ProductNames.AllProducts}
          titleType="primary"
          title={t("Banner.productName")}
          titleh1={t("Banner.title")}
          description={t("Banner.description")}
        />
        <ProductCardList
          type={ProductCategories.Analytics}
          categoryName={t("ProductList.analytic.name")}
          title={t("ProductList.analytic.title")}
          description={t("ProductList.analytic.description")}
        />
        <ProductCardList
          type={ProductCategories.Wallet}
          categoryName={t("ProductList.wallet.name")}
          title={t("ProductList.wallet.title")}
        />
        <ProductCardList
          type={ProductCategories.Compliance}
          categoryName={t("ProductList.compliance.name")}
          title={t("ProductList.compliance.title")}
        />
        <ProductCardList
          type={ProductCategories.NFT}
          categoryName={t("ProductList.nft.name")}
          title={t("ProductList.nft.title")}
        />
        <ProductCardList
          type={ProductCategories.Onboarding}
          categoryName={t("ProductList.onboarding.name")}
          title={t("ProductList.onboarding.title")}
        />
        <ProductCTA
          title={t("CTA.title")}
          primaryButton={{ text: t("CTA.button") }}
          secondaryButton={{ text: t("CTA.button2"), href: "/solutions" }}
          noArrow
        />
        <Footer />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "allProducts"
    ]))
  }
})

export default AllProductsPage
